import React from 'react';
import { CpIcon } from '@components';

export function Group(props) {
  const {
    name,
    icon,
    count,
    isSeparator
  } = props

  if (isSeparator) {
    return (
      <div className="cp-select-component__group-separator" />
    )
  }

  return (
    <div className="cp-select-component__group">
      <div className="cp-select-component__group-line" />
      <div className="cp-select-component__group-content">
        {icon && <CpIcon className="cp-mr-8" name={icon} />}
        {name} <span>({count} results)</span>
      </div>
    </div>
  );
}

Group.propTypes = {};
